export const getIntialValues = (data = {}) => {
  return {
    meta_seo: {
      meta_title: data?.meta_seo?.meta_title || "",
      meta_keyword: data?.meta_seo?.meta_keyword || "",
      meta_desc: data?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: data?.header?.primary_heading || "",
      secondary_heading: data?.header?.secondary_heading || "",
      description: data?.header?.description || "",

      primary_cta: data?.header?.primary_cta || { label: "", redirect_link: "" },
      secondary_cta: data?.header?.secondary_cta || { label: "", redirect_link: "" },
    },

    community: {
      heading: data?.community?.heading || "",
      community_table: data?.community?.community_table?.length
        ? data.community.community_table
        : [
            {
              title: "",
              community_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    workflow: {
      heading: data?.workflow?.heading || "",
      workflow_table: data?.workflow?.workflow_table?.length
        ? data.workflow.workflow_table
        : [
            {
              title: "",
              workflow_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    live_streams: {
      heading: data?.live_streams?.heading || "",
      live_table: data?.live_streams?.live_table?.length
        ? data.live_streams.live_table
        : [
            {
              title: "",
              live_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    features: {
      heading: data?.features?.heading || "",
      features_table: data?.features?.features_table?.length
        ? data.features.features_table
        : [
            {
              title: "",
              live_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    ai_agents: {
      heading: data?.ai_agents?.heading || "",
      agentss_table: data?.ai_agents?.agentss_table?.length
        ? data.ai_agents.agentss_table
        : [
            {
              title: "",
              agents_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    testimonials: {
      heading: data?.testimonials?.heading || "",
      testimonials: data?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};

export const generatePayload = (values) => {
  return {
    meta_seo: {
      meta_title: values?.meta_seo?.meta_title || "",
      meta_keyword: values?.meta_seo?.meta_keyword || "",
      meta_desc: values?.meta_seo?.meta_desc || "",
    },
    header: {
      primary_heading: values?.header?.primary_heading || "",
      secondary_heading: values?.header?.secondary_heading || "",
      description: values?.header?.description || "",

      primary_cta: values?.header?.primary_cta || { label: "", redirect_link: "" },
      secondary_cta: values?.header?.secondary_cta || { label: "", redirect_link: "" },
    },

    community: {
      heading: values?.community?.heading || "",
      community_table: values?.community?.community_table?.length
        ? values.community.community_table
        : [
            {
              title: "",
              community_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    workflow: {
      heading: values?.workflow?.heading || "",
      workflow_table: values?.workflow?.workflow_table?.length
        ? values.workflow.workflow_table
        : [
            {
              title: "",
              workflow_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    live_streams: {
      heading: values?.live_streams?.heading || "",
      live_table: values?.live_streams?.live_table?.length
        ? values.live_streams.live_table
        : [
            {
              title: "",
              live_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    features: {
      heading: values?.features?.heading || "",
      features_table: values?.features?.features_table?.length
        ? values.features.features_table
        : [
            {
              title: "",
              live_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    ai_agents: {
      heading: values?.ai_agents?.heading || "",
      agentss_table: values?.ai_agents?.agentss_table?.length
        ? values.ai_agents.agentss_table
        : [
            {
              title: "",
              agents_title: "",
              free: "",
              standard: "",
              advanced: "",
            },
          ],
    },

    testimonials: {
      heading: values?.testimonials?.heading || "",
      testimonials: values?.testimonials?.testimonials || [{ faq: "" }],
    },
  };
};
